<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="col-lg-12">
    <b-row>
        <b-col style="text-align:center">
          <h3>Recursos / Audios</h3>
        </b-col>
    </b-row>
    <div class="card">
      <div class="tab-content">
        <div class="tab-panel active">
          <div class="d-flex justify-content-between align-items-center mb-4 pl-4">
            <b-pagination class="p-0 m-0"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table">
            </b-pagination>
            <div class="d-flex align-items-center pl-3 mr-auto">
              <label class="p-0 m-0 pr-3 text-purple">Filtrar por tags</label>
              <vue-tags-input
                v-model="taglist"
                :autocomplete-items="tagslist"
                :add-only-from-autocomplete="true"
                @tags-changed="updatelist"
              />
            </div>
            <div class="col-md-3">
              <ResourceSearchs :routeApi="'audio'" ref="searchcomponent"
                :perPage = "perPage"
                :newTags2 = "newTags2"
                @update="onUpdateDataResource"
                @loading="onLoading"
              />
          </div>
            <b-button @click="onNew" variant="success">
              + Añadir
            </b-button>
          </div>
          <div class="row clearfix">
            <div class="col-lg-6" style="padding:0 !important"
            v-for="audio in resources" v-bind:key="audio.ID">
                <div class="row audio-card">
                    <div class="file-name col-lg-12 mb-3 d-flex align-items-center justify-content-between">
                        <p class="pt-2 text-muted" style="width:80%">{{audio.NOMBRE}}</p>
                        <div>
                          <button type="button"
                            class="btn btn-icon btn-icon-mini btn-round btn-info"
                            @click="editAudio(audio)">
                              <i class="zmdi zmdi-edit"></i>
                          </button>
                          <button type="button"
                            class="btn btn-icon btn-icon-mini btn-round btn-danger"
                            @click="deleteAudio(audio)">
                              <i class="fa fa-trash"></i>
                          </button>
                        </div>
                    </div>
                    <div class="col-lg-12 cardtheme">
                      <div class="audio d-flex align-items-center">
                          <audio :src="getTranslation(audio.FICHERO)" controls="controls"
                          style="width:100%" type="audio/mpeg" preload="preload">
                          </audio>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
      </div>
    </div>
  </div>


  <!-- Info modal -->
    <b-modal :id="infoModal.id" :title="infoModal.title" hide-footer>
       <div class="modal-body">
        <ValidationObserver ref="formValidation">
              <form @submit="formSubmit" enctype="multipart/form-data">
                      <ValidationProvider :rules="{required: true}" v-slot="{ errors }">
                        <label for="">Nombre</label>
                        <b-form-input
                          id="NOMBRE"
                          v-model="selectedItem.NOMBRE"
                          placeholder="Nombre..">
                        </b-form-input>
                        <span class="validation-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                      <br>
                       <div v-for="item in selectedItem.FICHERO" v-bind:key="item.LANGUAGE">
                          <ValidationProvider :rules="{required: true}" v-slot="{ errors }">
                        <label for="Ubicacion"> ES Audio a reemplazar - {{item.LANGUAGE}}:</label>
                          <!--<input type="file"
                          v-on:change="onImageChange" class="form-control">-->
                          <b-form-file accept="audio/*"
                            id="FICHERO_ALTA"
                            v-model="item.TEXTO"
                            :placeholder="item.TEXTO ? item.TEXTO.toString().replace(/storage\/|\?.*$/g, '') : 'Seleccione un audio o arrastre aquí...'"
                          ></b-form-file>
                          <span class="validation-error">{{ errors[0] }}</span>
                           </ValidationProvider>
                      </div>
                  <label for="Tag">
                       <br>
                          Etiquetas</label>
                            <div>
                            <vue-tags-input
                              v-model="tag"
                              :tags="tags"
                              :autocomplete-items="autocompleteItems"
                              @tags-changed="update"
                            />
                          </div>
                  <div class="box-footer">
                    <br>
                      <button type="submit" class="btn btn-info">Subir Audios</button>
                      <a class="btn btn-default" @click="$bvModal.hide('info-modal')">Cancelar</a>
                  </div>
              </form>
        </ValidationObserver>
       </div>
    </b-modal>


   <!--Modal para Editar un Audio-->
     <b-modal id="mdlEditarAudio" title="Editar Audio" hide-footer>
       <div class="modal-body">
         <ValidationObserver ref="formValidation">
              <form @submit="formSubmitEditarAudio" enctype="multipart/form-data">
                    <ValidationProvider :rules="{required: true}" v-slot="{ errors }">
                      <label for="">Nombre</label>
                      <b-form-input
                        id="NOMBRE"
                        v-model="selectedItem.NOMBRE"
                        placeholder="Nombre.."
                      >
                      </b-form-input>
                      <span class="validation-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                      <br>
                      <div v-for="item in selectedItem.FICHERO" v-bind:key="item.LANGUAGE">
                        <label for="Ubicacion"> ES Audio a reemplazar - {{item.LANGUAGE}}:</label>
                          <!--<input type="file"
                          v-on:change="onImageChange" class="form-control">-->
                          <b-form-file accept="audio/*"
                            id="FICHERO_EDITAR"
                            v-model="item.TEXTO"
                            :placeholder="item.TEXTO ? item.TEXTO.toString().replace(/storage\/|\?.*$/g, '') : 'Seleccione un audio o arrastre aquí...'"
                          ></b-form-file>
                      </div>
                      <br>
                      <label for="Tags">Etiquetas</label>
                        <div>
                        <vue-tags-input
                          v-model="tag"
                          :tags="tags"
                          :autocomplete-items="autocompleteItems"
                          @tags-changed="update"
                        />
                      </div>
                  <div class="box-footer">
                    <br>
                      <button type="submit" class="btn btn-info">Editar Audio</button>
                      <a class="btn btn-default"
                      @click="$bvModal.hide('mdlEditarAudio')">Cancelar</a>
                  </div>
              </form>
          </ValidationObserver>
       </div>
    </b-modal>
</div>

</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import VueTagsInput from '@johmun/vue-tags-input';
import ResourceSearchs from '../../../components/panel/ResourceSearchs.vue';
import searchMixin from '../../../mixins/search';
import translationMixin from '../../../mixins/translation';

extend('required', {
  ...required,
  message: 'Campo obligatorio.',
});

export default {
  components: {
    VueTagsInput, ResourceSearchs, ValidationProvider, ValidationObserver,
  },
  name: 'gridAudios',
  mixins: [searchMixin, translationMixin],
  data() {
    return {
      selectedCard: -1,
      perPage: 20,
      rows: 0,
      submitted: false,
      submittedModalEdit: false,
      currentPage: 1,
      ubicacion: null,
      resources: [],
      selectedItem: {
        ID: null,
        NOMBRE: null,
        FICHERO: [],
      },
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      tag: '',
      tags: [],
      newTags: [],
      tagslist: [],
      newTags2: [],
      taglist: '',
      autocompleteItems: [],
    };
  },
  methods: {
    hoverCard(selectedIndex) {
      this.selectedCard = selectedIndex;
    },
    isSelected(cardIndex) {
      return this.selectedCard === cardIndex;
    },
    listTags() {
      const url = 'Tags';
      const datos = [];
      this.axios.get(url).then((res) => {
        res.data.forEach((a) => {
          datos.push({ key: a.ID, text: a.NOMBRE });
        });
        this.tagslist = datos;
      })
        .catch((error) => {
          console.error(error);
        });
      this.loading = false;
    },
    updatelist(newTags) {
      this.newTags2 = newTags;
      this.getPostData();
    },
    editAudio(audio) {
      this.limpiar();
      this.newTags = [];
      this.selectedItem.ID = audio.ID;
      this.selectedItem.NOMBRE = audio.NOMBRE;
      this.selectedItem.FICHERO = audio.FICHERO;
      this.$root.$emit('bv::show::modal', 'mdlEditarAudio');

      this.getExistingTags(audio.ID);
    },
    async deleteAudio(audio) {
      const confirmation = await this.$bvModal.msgBoxConfirm('Esta a punto de eliminar un audio ¿Esta seguro?');
      if (confirmation) {
        this.loading = true;
        const response = await this.axios.post('audio/deleteaudio', { ID: audio.ID });
        if (response.data.status === 'success') {
          this.loading = false;
          this.$toasted.show('Se elimino el audio seleccionado.', { theme: 'outline', type: 'success', duration: 5000 });
          this.getPostData();
        } else {
          this.loading = false;
          this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
        }
      }
    },
    async formSubmitEditarAudio(e) {
      this.$refs.formValidation.validate().then((success) => {
        e.preventDefault();
        if (!success) {
          return;
        }
        this.loading = true;
        const idaud = this.selectedItem.ID;
        const config = {
          headers: { 'content-type': 'multipart/form-data' },
        };
        const formData = new FormData();
        formData.append('ID', this.selectedItem.ID);
        formData.append('NOMBRE', this.selectedItem.NOMBRE);
        const prefijo = 'FICHERO_';
        this.selectedItem.FICHERO.forEach((element) => {
          formData.append(`${prefijo + element.LANGUAGE}`, element.TEXTO);
        });
        this.axios.post('audio/editaudio', formData, config)
          .then((response) => {
            if (response.data.status === 'success') {
              const url = `Tagsaudios/deleteTags/${this.selectedItem.ID}`;
              const url2 = 'Tagsaudios/saveTag';

              this.axios.get(url);
              this.newTags.forEach((a) => {
                this.axios.get(`Tags/findTagByName/${a.text}`,
                  { name: a.text }).then((resp) => {
                  if (resp.data.status === 'success') {
                    this.axios.post(url2, { id: resp.data.id, idaudio: idaud });
                  } else {
                    this.axios.post(url2, { id: a.key, idaudio: idaud });
                  }
                });
              });

              this.$toasted.show('Los datos se guardaron satisfactoriamente.', { theme: 'outline', type: 'success', duration: 5000 });
              this.$root.$emit('bv::hide::modal', 'mdlEditarAudio');
              this.limpiar();
              this.getPostData();
            } else {
              this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
            }
            this.loading = false;
          });
      });
    },
    async formSubmit(e) {
      this.$refs.formValidation.validate().then((success) => {
        e.preventDefault();
        if (!success) {
          return;
        }
        this.loading = true;
        const config = {
          headers: { 'content-type': 'multipart/form-data' },
        };
        const formData = new FormData();
        formData.append('NOMBRE', this.selectedItem.NOMBRE);
        const prefijo = 'FICHERO_';
        this.selectedItem.FICHERO.forEach((element) => {
          formData.append(`${prefijo + element.LANGUAGE}`, element.TEXTO);
        });
        this.axios.post('audio/upload', formData, config)
          .then((response) => {
            if (response.data.status === 'success') {
              const bc = new BroadcastChannel('new_resource_audio');
              bc.postMessage({
                ID: response.data.id,
                NOMBRE: this.selectedItem.NOMBRE,
                FICHERO: response.data.FICHERO,
              });

              const url = `Tagsaudios/deleteTags/${response.data.id}`;
              const url2 = 'Tagsaudios/saveTag';

              this.axios.get(url);
              this.newTags.forEach((a) => {
                this.axios.get(`Tags/findTagByName/${a.text}`,
                  { name: a.text }).then((resp) => {
                  if (resp.data.status === 'success') {
                    this.axios.post(url2, { id: resp.data.id, idaudio: response.data.id });
                  } else {
                    this.axios.post(url2, { id: a.key, idaudio: response.data.id });
                  }
                });
              });

              this.$toasted.show('Los datos se guardaron satisfactoriamente.', { theme: 'outline', type: 'success', duration: 5000 });
              this.$root.$emit('bv::hide::modal', this.infoModal.id);
              this.limpiar();

              // Auto close if coming from a create event
              if (this.bAutoClose) {
                window.open('', '_self').close();
              }

              this.getPostData();
            } else {
              this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
            }
            this.loading = false;
          });
      });
    },
    onNew() {
      this.limpiar();
      this.languages.forEach((language) => {
        this.selectedItem.FICHERO.push({
          LANGUAGE: language,
          TEXTO: null,
        });
      });
      this.infoModal.title = 'Nuevo Audio';
      this.$root.$emit('bv::show::modal', this.infoModal.id);
    },
    limpiar() {
      this.submitted = false;
      this.submittedModalEdit = false;
      this.selectedItem.ID = null;
      this.selectedItem.NOMBRE = null;
      this.selectedItem.FICHERO = [];
      this.tag = '';
      this.tags = [];
    },
    async ondelete(item) {
      const confirmation = await this.$bvModal.msgBoxConfirm('Esta a punto de eliminar un registro ¿Esta seguro?');
      if (confirmation) {
        /** Elimino los tags asociados */
        const url = `Tagsaudios/deleteTags/${item.ID}`;
        this.axios.get(url);

        this.loading = true;
        const response = await this.axios.post('text/delete', { ID: item.ID });
        if (response.data.status === 'success') {
          await this.getPostData();
          this.loading = false;
          this.$toasted.show('Se elimino el registro seleccionado.', { theme: 'outline', type: 'success', duration: 5000 });
        } else {
          this.loading = false;
          this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
        }
      }
    },
    async getPostData() {
      this.loading = true;
      try {
        const response = await this.axios.get('audio', {
          params: {
            currentPage: this.currentPage,
            size: this.perPage,
            newTags: this.newTags2,
            resourcetosearch: this.$refs.searchcomponent.resoursetosearch,
          },
        });
        this.rows = response.data.rows;
        this.resources = Object.keys(response.data.results).map(k => response.data.results[k]);
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    initItems() {
      const url = 'Tags';
      const datos = [];

      this.axios.get(url).then((res) => {
        res.data.forEach((a) => {
          datos.push({ text: a.NOMBRE, key: a.ID });
        });
        this.autocompleteItems = datos;
      })
        .catch((error) => {
          console.error(error);
        });
      this.loading = false;
    },
    update(newTags) {
      this.tags = newTags;
      this.newTags = newTags;
    },
    async getExistingTags(idtxt) {
      const url = `Tagsaudios/findByaudio/${idtxt}`;
      const datos = [];
      this.loading = true;

      try {
        this.axios.get(url).then((res) => {
          res.data.forEach((a) => {
            datos.push({ text: a.NOMBRE, key: a.ID });
          });
          this.tags = datos;
        })
          .catch((error) => {
            console.error(error);
          });
        this.loading = false;
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },
  },
  async mounted() {
    await this.getPostData();
    this.initItems();
    this.listTags();

    // Open create modal automatically
    const self = this;
    const bc = new BroadcastChannel('new_resource_audio_open');
    bc.onmessage = () => {
      self.bAutoClose = true;
      self.onNew();
    };

    // Get params Id for edit
    if (this.$route.params.id != null) {
      const response = await this.axios.get('audio/getaudio', {
        params: {
          id: this.$route.params.id,
        },
      });
      this.editImage(this.$route.params.id, response.data.NOMBRE, 'ES');
    }
  },
  watch: {
    currentPage: {
      handler() {
        this.getPostData().catch((error) => {
          console.error(error);
        });
      },
    },
  },
};
</script>
<style>
.cardtheme {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.hover {
    -moz-transition: all 0.5s;
    -o-transition: all 0.5s;
    -webkit-transition: all 0.5s;
    transition: all 0.5s;
    width: 120px;
    display: block;
    text-align: right;
}
.nombreRecurso{
  color:#0c7ce6
}
.audio {
    width: 100%;
    overflow: hidden;
    min-height: 0 !important;
  }
 .file .ActiveButton {
 -moz-transition: all 0.5s;
    -o-transition: all 0.5s;
    -webkit-transition: all 0.5s;
    transition: all 0.5s;
    position: absolute;
    right: 1px;
    top: -1px;
    display: block !important;
}
</style>
